module.exports = __webpack_public_path__ + "media/audio71.60877bbe.mp3";